const ar = {
  home: 'الرئيسية',
  dashboard: 'لوحة المعلومات',
  noServicesFoundPleaseTryAgain: 'لا توجد خدمات',
  serviceUsage: 'استخدام الخدمة',
  more: 'المزيد',
  close: 'إغلاق',
  verificationServices: {
    title: 'خدمات التحقق',
    description: 'تمكنك هذه الخدمة من التحقق من الوثائق الصادرة من وزارة العدل إلكترونياً',
    userNeed: 'أريد التحقق من',
    browseVerificationServices: 'تصفح خدمات التحقق',
  },

  electronicServices: {
    title: 'الخدمات الإلكترونية',
    mostUsed: 'الأكثر إستخداما',
    judiciary: 'القضاء',
    realEstate: 'العقاري',
    documentation: 'التوثيق',
    lawyers: 'المحامين',
  },
  search: 'بحث',
  back: 'رجوع',
  endDate: 'تاريخ الانتهاء',
  currentServices: 'خدماتي الحالية',
  searchResult: 'نتائج البحث',
  realEstates: 'صكوك العقارات الالكترونية',
  marrigeContracts: 'طلبات الزواج الالكترونية',
  judicialLicences: 'التراخيص العدلية',
  searchLengthError: 'رساله البحث اقل من أربعة مقاطع',
  all: 'الكل',
  faq: 'الأسئلة الشائعة',
  loading: 'جاري تحميل البيانات',
  useTheService: 'الانتقال إلى الخدمة',
  startTheService: 'بدء الخدمة',
  portalServices: {
    title: 'الخدمات الإلكترونية',
    searchInServices: 'ابحث في الخدمات الإلكترونية',
    allServices: 'جميع الخدمات',
    readMore: 'شرح الخدمة',
    use: 'ابدأ الخدمة',
    new: 'جديد',
    newlyAdded: 'جديد',
    modified: 'محدث',
    favorites: 'المفضلة',
    mostUsed: 'الأكثر استخداما',
    useTheService: 'استخدام الخدمة',
    moveToService: 'الانتقال الى خدمة',
  },
  serviceDetails: {
    describeService: 'وصف الخدمة',
    steps: 'خطوات التقديم على الخدمة',
    serviceRequirements: 'متطلبات الخدمة',
    channels: 'قنوات تقديم الخدمة',
    serviceInformation: 'يجب أن تعرف',
  },
  router: {
    licenseGuide: 'دليل المرخصين',
    notifications: 'الاشعارات',
    verificationServices: 'خدمات التحقق',
    privacyPolicy: 'سياسة الخصوصية',
    termsAndConditions: 'الشروط والأحكام',
    home: 'الرئيسية',
    mostUsedServices: 'الخدمات الإلكترونية',
    theSearch: 'البحث',
    contactUs: 'تواصل معنا',
  },
  telemetry: {
    quickAccessLink: 'النقر على رابط التنقل السريع لخدمة',
    moreDetails: 'النقر على رابط المزيد لبطاقة',
    serviceLink: 'النقر على رابط الخدمة:',
    forCard: 'لبطاقة',
    dashboarLink: 'الوصول الى لوحة المعلومات',
  },
  serverErrors: {
    NOT_FOUND: 'لا يمكننا خدمتك في الوقت الحالي. الرجاء المحاولة لاحقاً',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
  },
  fetchingData: 'جاري تحميل البيانات ...',
  viewSearchResults: 'عرض نتيجة البحث ({count} نتيجة)',
  browseService: 'تصفح الخدمة ',
  noSearchResultsFound: 'لا يوجد نتائج تطابق البيانات المدخلة',
  pleaseRevalidateSearchCriteriaAndCheckAgain: 'الرجاء التأكد من البيانات، والمحاولة مجدداً.',
  mostProminentServices: 'أبرز الخدمات',
  showMore: 'عرض المزيد',
  showDetails: 'عرض التفاصيل',
  latestNotifications: 'آخر الإشعارات',
  judicialProfile: 'الملف العدلي',
  judicialProfileDescription: 'كل مايخص معلوماتك العدلية القضاء والوكالات وغيرها من الخدمات. ',
  judicialProfileFirstDescription: 'كل مايخص معلوماتك العدلية ',
  judicialProfileSecondDescription: ' من القضاء والوكالات وغيرها من الخدمات.',
  viewAll: 'مشاهدة الكل',
  viewLess: 'مشاهدة أقل',
  serviceExecutionTime: 'مدة تنفيذ الخدمة',
  serviceExecutionTimeDescription: 'من {from} إلى {to}',
  serviceProviderChannels: 'قنوات تقديم الخدمة',
  beneficiaries: 'الفئة المستهدفة',
  serviceFees: 'رسوم الخدمة ',
  commonFaqs: 'الأسئلة الشائعة',
  checkFaqs: 'الاطلاع على الأسئلة الشائعة',
  clickHere: 'اضغط هنا',
  allServices: 'جميع الخدمات',
  downloadApp: 'تحميل تطبيق ناجز',
  usageGuide: 'دليل الأستخدام',
  downloadUsageGuide: 'تنزيل دليل الإستخدام',
  theDescription: 'الوصف',
  theRequirments: 'المتطلبات',
  theSteps: 'الخطوات',
  serviceDescription: 'وصف الخدمة',
  serviceRequirments: 'متطلبات الخدمة',
  stepsToApplyForTheService: 'خطوات التقديم على الخدمة',
  submitNewRequest: 'تقديم طلب جديد',
  followUpOnPreviousRequest: 'متابعة طلب سابق',
  authenticationOfCompletedRequest: 'مصادقة طلب مكتمل',
  youShouldKnow: 'يجب أن تعرف',
  share: 'مشاركة',
  copyServiceLink: 'نسخ رابط الخدمة',
  serviceLinkCopiedSuccessfully: 'تم نسخ رابط الخدمة بنجاح',
  attorneyUpdatedSuccessfully: 'تم تحديث بيانات الوكالة بنجاح',
  instant: 'فورية',
  sections: 'الأقسام',
  searchResults: 'نتائج البحث ({searchText})',
  searchResultFor: 'نتيجة البحث عن',
  resultFound: 'نتيجة وجدت',
  sessionFollowUp: 'متابعة الجلسة',
  accountUdpdatedSuccesfully: 'تم تحديث بيانات الحساب بنجاح',
  accountsManagements: 'إدارة الحساب',
  email: 'البريد الإلكتروني',
  withMaxLengthChars: 'بحد أقصى {length} حرف',

  contactWithUs: {
    title: 'تواصل معنا',
    slogan: 'نحن نعمل بشكل مستمر لجعل تجربتك مع الخدمات العدلية أسهل، تعرف على قناة الدعم التي تناسب احتياجاتك بشكل أفضل.',
    contactInsideKSA: 'تواصل معنا من داخل المملكة',
    fromSunToThurs: 'من الأحد إلى الخميس',
    fromInsideKSA: 'من داخل المملكة العربية السعودية',
    contactUs: 'تواصل معنا',
    contactOutsideKSA: 'اتصل بنا من خارج المملكة',
    contactTime: 'من 8 صباحاً إلى 2:15 مساءً (الأحد - الخميس)',
    fromOutsideKSA: 'من خارج المملكة العربية السعودية',
    messageUs: 'راسلنا',
    allWeekDays: 'طوال أيام الاسبوع',
    allTheTime: 'جميع الأوقات',
    instantChat: 'المحادثة الفورية',
    chatWithUs: 'تحدث معنا',
    pleaseToServeYou: 'نسعد بخدمتكم بجميع مراكز ناجز',
    najizCenterRiyadhBranch: 'مركز ناجز فرع الرياض',
    najizCenterRiyadhBranchLocation: 'طريق أنس ابن مالك، الملقا، الرياض 13524',
    location: 'الموقع',
    workingDays: 'أيام العمل',
    workingTime: 'أوقات العمل',
    from: 'من',
    until: 'حتى',
    atMorning: 'صباحاً',
    atNight: 'مساًء',
    najizCenterJeddahBranch: 'مركز ناجز فرع جدة',
    najizCenterJeddahBranchLocation: 'ساري ، حي الخالدية ،جدة 23423',
    najizCenterDammamBranch: 'مركز ناجز فرع الدمام',
    najizCenterDammamBranchLocation: 'طريق الظهران الجبيل السريع، الروضة،,الدمام',
    socialMediaAccounts: 'حسابات التواصل الاجتماعي',
    x: 'إكس',
    instagram: 'إنستقرام',
    snapchat: 'سناب شات',
    youtube: 'يوتيوب',
    facebook: 'فيسبوك',
    linkedin: 'لينكد إن',
    contactChannels: 'قنوات استقبال الاستفسارات والشكاوى',
    name: 'الاسم الاول',
    enterTheName: 'ادخل الاسم الاول',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'ادخل البريد الالكتروني',
    phone: 'رقم الجوال',
    phoneLabel: 'الهاتف',
    phonePlaceholder: '05xxxxx',
    messageTitle: 'عنوان الرسالة',
    messageTitlePlaceholder: 'اكتب موضوعك',
    messageCategory: 'فئة الرسالة',
    messageText: 'نص الرسالة',
    theMessage: 'نص تلميحي',
    send: 'إرسال',
    serviceAvailability: 'توفر الخدمة',
    contactNumber: 'رقم التواصل',
    responseTime: 'زمن الاستجابة',
    instant: 'فوري',
    serviceType: 'نوع الخدمة',
    liveChat: 'محادثة مباشرة',
    inquiriesAndComplaints: 'الاستفسارات والشكاوى',
    supportWithSignLanguage: 'الدعم بلغة الإشارة',
    tenDaysWork: '10 أيام عمل',
    twoWorkDays: 'يومين عمل',
    judicialContact: 'التواصل العدلي',
    signSupport: 'دعم الإشارة',
    question: 'سؤال',
    suggestion: 'اقتراح',
    help: 'مساعدة',
    messageSentSuccessfully: 'تم إرسال الرسالة بنجاح',
    contactSample: 'نموذج الاتصال',
  },

  validations: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    maxInputsLength: 'أقصى عدد للمدخلات هو {length}',
    numbersExactLength: ' عدد الأرقام يجب أن يكون {length}',
    startsWith: ' يجب أن يبدأ ب {listText}',
    phoneNumber: 'يجب أن يبدأ رقم الجوال ب {key} وأن يكون {length} أرقام',
    emailAddress: 'الرجاء إدخال بريد إلكتروني صحيح',
    onlyArabicAndNumbers: 'الرجاء إدخال أحرف عربية وأرقام فقط.',
    onlyArabicOrNumbers: 'الرجاء إدخال أحرف عربية أو أرقام فقط.',
    specialCharacters: 'الرجاء عدم إدخال رموز خاصة.',
    twitterId: 'يجب أن يكون المعرف كالآتي http(s)://twitter.com/xyz123',
    facebookId: 'يجب أن يكون المعرف كالآتي http(s)://facebook.com/xyz123',
    minWordsLength: 'أقل عدد للكلمات يجب أن يكون {length}',
    theNameMustBeBinary: 'يجب أن يكون الإسم ثنائياً',
    onlyArabic: 'يجب إدخال أحرف عربية فقط',
    duplicatePhoneNumberInContactInfo: 'يجب أن لايتطابق رقم الشخص الأول مع الشخص الثاني',
    duplicatePhoneNumberInApplicantInfo: 'يجب أن لايتطابق رقم الجوال مع رقم الجوال في البيانات الشخصية',
    alphaNumeric: 'الرجاء إدخال أحرف إنجليزية وأرقام  فقط.',
    alphaNumericAndSpecialChars: 'الرجاء إدخال أحرف إنجليزية وأرقام ورموز خاصة مثل {chars}',
  },

  faqs: {
    title: 'الأسئلة المتكررة',
    description: 'اعثر على إجابات للأسئلة الشائعة حول منتجاتنا، خدماتنا، وسياساتنا.',
    searchPlaceholder: 'ابحث هنا، مثلاً: كيفية إنشاء صحيفة دعوى',
    howCanWeHelpYou: 'كيف يمكننا مساعدتك؟',
    browseAllQuestions: 'تصفح جميع الأسئلة',
    noQuestionsAvailable: 'لا توجد أسئلة.',
    shareQuestion: 'مشاركة السؤال',
    questionLinkCopiedSuccessfully: 'تم نسخ رابط السؤال بنجاح',
    questionDetails: 'تفاصيل السؤال',
    questionDetailsNotAvailable: 'بيانات السؤال غير متاحة',
  },
  contactUs: {
    title: 'تواصل معنا',
    forMoreContacts: 'لمزيد من قنوات التواصل',
  },
  feedbackCard: {
    title: 'التعليقات والاقتراحات',
    description: 'لأي استفسار أو ملاحظات حول الخدمات الحكومية، يرجى ملء المعلومات المطلوبة.',
  },
  guideDialog: {
    title: 'تصفح دليل الخدمة حجز موعد كتابات العدل المتنقلة بنسق ميسر',
    browseGuideAccessible: 'تصفح دليل الخدمة بنسق ميسر',
    tabs: {
      login: 'أولاً: آلية تسجيل الدخول',
      steps: 'ثانياً: خطوات تنفيذ الخدمة',
      contact: 'ثالثاً: تواصل معنا',
    },
    login: {
      title: 'أولاً : آلية  تسجيل الدخول',
      mainPageAccess: 'الدخول إلى الصفحة الرئيسية لمنصة ناجز',
      step1: 'من الصفحة الرئيسية اختر (أفراد) لتسجيل الدخول كمواطن أو مقيم أو زائر.',
      step2: 'يتم الإنتقال إلى صفحة تسجيل الدخول عبر النفاذ الوطني، ويمكن تسجيل الدخول ، عن طريق إدخال رقم الهوية/الإقامة مباشرة والضغط على تسجيل الدخول.',
      step3: 'وتأكيد الرقم الظاهر عن طريق فتح تطبيق نفاذ الذي تم تنزيله مسبقًا. بعد تأكيد الرمز، يتم إعادة التحويل إلى الصفحة الرئيسية لموقع ناجز.',
      step4: 'أو عن طريق الضغط على زر "تسجيل الدخول" باستخدام اسم المستخدم وكلمة المرور، ثم يتم الانتقال إلى صفحة النفاذ الوطني الموحد.',
      imageAlt: 'خطوة تسجيل الدخول',
    },
    steps: {
      title: 'ثانياً : خطوات تفيذ الخدمة',
      intro: 'يتم من خلال الشريط العلوي اختيار (الخدمات الإلكترونية) لعرض جميع الخدمات المتاحة، ثم يتم من القائمة الجانبية اختيار (باقة المواعيد)، واختيار خدمة (حجز موعد كتابات العدل المتنقلة)، والضغط على زر (استخدام الخدمة) للاطلاع على وصف الخدمة ومتطلباتها، ومن ثم الضغط على زر (تقديم طلب جديد)',
      afterSubmit: 'بعد تقديم طلب جديد، يتم تعبئة خطوات الخدمة بالترتيب التالي:',
      step1Title: 'الخطوة الأولى: بيانات المستفيد',
      step1Item1: 'يتم اختيار صفة مقدم الطلب: عن نفسي أو نيابة عن المستفيد.',
      step1Item2: 'عند اختيار "عن نفسي": يتم استرجاع معلومات رقم الهوية وتاريخ الميلاد تلقائيًا.',
      step1Item3: 'عند اختيار "نيابة عن المستفيد": يجب إدخال رقم الهوية وتاريخ الميلاد، ثم يتم التحقق منها.',
      step1Item4: 'بعد ذلك، يتم إدخال رقم الجوال ونوع المستفيد المطلوب تقديم الخدمة له وإلانتقال إلى التالي',
      step2Title: 'الخطوة الثانية : تفاصيل الخدمة',
      step2Item1: 'يتم اختيار نوع الخدمة: إما خدمة إصدار الوكالات أو خدمة الإفراغ العقاري.',
      step2Item2: 'بعد اختيار نوع الخدمة، يتم إدخال جميع المعلومات المتعلقة بالخدمة المختارة.',
      step2Item3: 'بعد استكمال المعلومات، يتم الانتقال إلى الخطوة التالية.',
      step3Title: 'الخطوة الثالثة :بيانات الموقع',
      step3Item1: 'يتم السماح للمنصة بالوصول إلى الموقع لتحديد الموقع بدقة على الخريطة.',
      step3Item2: 'بعد تحديد الموقع، يتم الانتقال إلى الخطوة التالية.',
      step4Title: 'الخطوة الرابعة :المواعيد المتاحة',
      step4Item1: 'يتم اختيار تاريخ ووقت الموعد المتاح حسب رغبة المستخدم.',
      step4Item2: 'بعد اختيار التاريخ والوقت، يمكن الانتقال إلى معاينة الطلب قبل الإرسال.',
      step5Title: 'الخطوة الخامسة :معاينة الطلب',
      step5Item1: 'بعد استكمال جميع خطوات الخدمة، يتم معاينة تفاصيل الطلب للتأكد من صحة جميع البيانات المدخلة.',
      step5Item2: 'بعد التأكد، يتم الضغط على إرسال الطلب.',
      step5Item3: 'تظهر رسالة تؤكد نجاح العملية مع عرض معلومات الموعد المحجوز.',
      imageAlt: 'خطوة تسجيل الدخول',
    },
    contact: {
      title: 'ثالثاً: تواصل معنا',
      subtitle: 'نسعد بتقديم الدعم من خلال قنوات التواصل',
      ticketService: 'خدمة إنشاء',
      ticketServiceBold: 'تذكرة التواصل العدلي',
      unifiedNumber: 'الرقم الموحد',
      unifiedNumberValue: '1950',
      email: 'البريد التواصل',
      emailValue: '1950@moj.gov.sa',
    },
  },
};

export default ar;
